"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportNumberRegex = exports.pileNumberRegex = exports.sectorNumberRegex = exports.reportKeyRegex = exports.pileKeyRegex = exports.sectorKeyRegex = void 0;
exports.sectorKeyRegex = /^s\:\d+$/;
exports.pileKeyRegex = /^s\:\d+\:p\:\d+[abcdef]?$/i;
exports.reportKeyRegex = /^r\:\d+\:s\:\d+$/;
exports.sectorNumberRegex = /^s\:(\d+)$/;
exports.pileNumberRegex = /^s\:\d+\:p\:(\d+[abcdef]?)$/i;
exports.reportNumberRegex = /^r\:(\d+)\:s\:\d+$/;
